import {confMapsService} from "../../jwt/_services/configuration/confMapsService";

export const mapFunctions = {
    loadMapConfig,
    mapMarkersToPointsArray,
    mapResultToMarkers,
    mapPointsToMarkers,
    getMidElement,
    getLastToFirst
};

async function loadMapConfig( _udn ) {
    try {
        if (_udn.id !== undefined) {
            // let dataRequest = {
            //     platform: "ANDROID",
            //     udn: { id: _udn.id }
            // }
            let dataRequest = {
                item: {
                    platform: "ANDROID",
                    udn: {id: _udn.id}
                }
            }

            return await confMapsService.search(0, 1000, dataRequest )
        }
    }
    catch (ex) {
        console.log(ex)
    }
}

function mapPointsToMarkers(_points) {
    try {
        let result = []

        _points.map(_point => {
            result.push(
                {
                    id: _point.id,
                    showOrder: _point.showOrder,
                    originalOrder: _point.showOrder,
                    position: {
                        lat: parseFloat(_point.lat || 0.0),
                        lng : parseFloat(_point.lng || 0.0),
                        alt: parseFloat(_point.alt || 0.0)
                    },
                }
            )
        });

        return result
    }
    catch (ex) {
        console.log(ex)
    }
}

function mapMarkersToPointsArray(_markers, _udn, _ratio) {
    try {
        let positionArray = []

        _markers.map(_marker => {
            positionArray.push(
                {
                    id: _marker.id,
                    udn : { id : _udn.id},
                    ratio : _ratio,
                    // code: ( parseFloat(_marker.position.lat) + ',' + parseFloat(_marker.position.lng) ),
                    lat: parseFloat(_marker.position.lat || 0.0),
                    lng : parseFloat(_marker.position.lng || 0.0),
                    alt : parseFloat(_marker.position.alt || 0.0),
                }
            )
        });

        return positionArray
    }
    catch (ex) {
        console.log(ex)
    }
}

function mapResultToMarkers(data) {
    try {
        let markersMaped = []

        data.map(_marker => {
            markersMaped.push(
                {
                    id: _marker.id,
                    code : _marker.number,
                    name : _marker.name,
                    showMarker : true,
                    position: { lat: parseFloat(_marker.latitude || 0.0), lng : parseFloat(_marker.longitude || 0.0), alt : parseFloat(_marker.altitude || 0.0) },
                }
            )
        });

        return markersMaped
    }
    catch (ex) {
        console.log(ex)
    }
}

function getMidElement (array) {
    try {
        if (array.length === 1)
            return array[0]

        const long = array.length;
        const midIndex = Math.floor(long / 2);

        if (long % 2 !== 0) {
            return array[midIndex];
        }

        return array[midIndex - 1];
    }
    catch (ex) {
        console.log(ex)
    }
}

function getLastToFirst (array) {
    try {
        let lastElement = array.length === 1 ? array[0] : array[array.length - 1];
        lastElement = {
            ...lastElement,
            id : undefined,
            showOrder : 0
        }
        // lastElement.position.lat = array[array.length - 1].position.lat || array[array.length - 1].lat;
        // lastElement.position.lng = array[array.length - 1].position.lng || array[array.length - 1].lng;
        // lastElement.showOrder = 0;
        return lastElement;
    }
    catch (ex) {
        console.log(ex)
    }
}